module.exports = __webpack_public_path__ + "static/media/FiraSans-Thin.979e1f11.ttf";